const constants = {};

/* GET TEAM */
constants['GET_TEAM_PENDING'] = 'COMPANY/GET_TEAM_PENDING';
constants['GET_TEAM_SUCCESS'] = 'COMPANY/GET_TEAM_SUCCESS';
constants['GET_TEAM_ERROR'] = 'COMPANY/GET_TEAM_ERROR';

export default constants;
